import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

// Register the components Chart.js needs
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const MonthlyExpenseChart = ({ data }) => {

    const chartData = {
        labels: data.map(item => item.month),
        datasets: [
            {
                label: 'Total Expense',
                data: data.map(item => item.totalAmount),
                backgroundColor: '#2dd4bf', // Teal 400
                hoverBackgroundColor: '#0d9488', // Teal 600
                borderRadius: 8,
                barThickness: 40,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false, // Hide legend for a cleaner "KPI" look
            },
            tooltip: {
                backgroundColor: '#1e293b', // Slate 800
                padding: 12,
                titleFont: { size: 14, weight: 'bold' },
                bodyFont: { size: 13 },
                displayColors: false,
                callbacks: {
                    label: (context) => `₹${context.raw.toLocaleString('en-IN')}`,
                },
            },
        },
        scales: {
            x: {
                grid: {
                    display: false, // Clean look, no vertical lines
                },
                ticks: {
                    color: '#9ca3af', // Gray 400
                    font: { size: 12 },
                },
                border: {
                    display: false,
                },
            },
            y: {
                grid: {
                    color: '#f1f5f9', // Very light slate lines
                    drawBorder: false,
                },
                ticks: {
                    color: '#9ca3af',
                    font: { size: 12 },
                    callback: (value) => `₹${value}`,
                },
                border: {
                    display: false,
                    dash: [5, 5],
                },
            },
        },
    };

    return (
        <div className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100 mb-8 transition-all hover:shadow-md">
            <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-bold text-slate-800">Monthly Expense Trend</h3>
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest bg-slate-50 px-3 py-1 rounded-full">
                    Cash Outflow
                </span>
            </div>
            <div className="h-64 w-full">
                <Bar data={chartData} options={options} />
            </div>
        </div>
    );
};

export default MonthlyExpenseChart;